<div id="modal" class="modal modal__small" style="display: block" (click)="onCloseModal()" >

    <!-- Modal content -->
    <div class="content" [ngClass]=" showingDialog ? 'animated bounceInDown' : 'animated bounceOutUp'" (click)="stopEvent( $event )">
  
      <span class="close" (click)="onCloseModal()">
        <svg class="icon"><use xlink:href="assets/symbol-defs.svg#icon-close"></use></svg>
        
      </span>
  
      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="centered small">
  
        <div *ngIf="submitted && confirmPassword?.errors" class="alert alert-danger">
            Die Passwörter stimmen nicht überein.
        </div> 
  
        <div *ngIf="submitted && error !=='' " class="alert alert-danger">
          Die Passwörter stimmen nicht überein.
        </div> 
  
        <div class="form-row">
          <div class="form-group">
              <label for="title">Ihr aktuelles Passwort</label>
              <input type="password" formControlName="password" [ngClass]="{'invalid': submitted && password?.invalid}" >
          </div> 
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="title">Neues Passwort</label>
            <input formControlName="newPassword" [ngClass]="{'touched': newPassword?.dirty || newPassword?.value !== '', 'invalid': submitted && newPassword?.invalid}"
              type="password" placeholder=" " autocomplete="off">
            
          </div>
        </div>
  
        <div class="form-row">
          <div class="form-group">
            <label for="title">Neues Passwort bestätigen</label>
            <input formControlName="confirmPassword" [ngClass]="{'touched': confirmPassword?.dirty || confirmPassword?.value !== '', 'invalid': submitted && confirmPassword?.invalid}"
              type="password" placeholder=" " autocomplete="off">
            
          </div>
        </div>
  
        <div class="btns-group mt-2 flex flex-end">
            <button class="btn btn-raised right" >
                <span>Passwort ändern</span>
                <svg class="icon"><use xlink:href="assets/symbol-defs.svg#icon-chevron-right"></use></svg>
            </button>
        </div>
  
      </form>
    </div>
  
  </div>